import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/Index.vue";
import Register from "../views/Register.vue";
import Birthday from "../views/Birthday.vue";
import Cards from "../views/Cards.vue";
import SingleCard from "../views/SingleCard.vue";
import Search from "../views/Search.vue";
import BingoTop from "../views/BingoTop.vue";
import Bingo from "../views/Bingo.vue";
import Songs from "../views/Songs.vue";
import Lives from "../views/Lives.vue";
import LiveDetail from "../views/LiveDetail.vue";
import SongDetail from "../views/SongDetail.vue";
import Quiz from "../views/Quiz.vue";
import Summary from "../views/Summary.vue";
import Report from "../views/Report.vue";
import AIImages from "../views/AIImages.vue";
import MyPage from "../views/MyPage.vue";
import MyPageRedirect from "../views/MyPageRedirect.vue";

import KitamiRine from "../views/KitamiRine.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: Index,
  },
  {
    path: "/cards",
    name: "cards",
    component: Cards,
  },
  {
    path: "/cards/images/:imageId",
    name: "single-card",
    component: SingleCard,
  },
  {
    path: "/register",
    name: "register",
    component: Register,
  },
  {
    path: "/birthday/:hash",
    name: "birthday",
    component: Birthday,
  },
  {
    path: "/search",
    name: "search",
    component: Search,
  },
  {
    path: "/songs",
    name: "songs",
    component: Songs,
  },
  {
    path: "/songs/:id",
    name: "songDetail",
    component: SongDetail,
  },
  {
    path: "/lives",
    name: "lives",
    component: Lives,
  },
  {
    path: "/lives/:key",
    name: "liveDetail",
    component: LiveDetail,
  },
  {
    path: "/bingo",
    name: "bingoTop",
    component: BingoTop,
  },
  {
    path: "/bingo/:bingoId",
    name: "bingo",
    component: Bingo,
  },
  {
    path: "/kitamirine2022",
    name: "kitamirine",
    component: KitamiRine,
  },
  {
    path: "/quiz",
    name: "quiz",
    component: Quiz,
  },
  {
    path: "/mypage",
    name: "mypageRedirect",
    component: MyPageRedirect,
  },
  {
    path: "/minasan/:userId",
    name: "mypage",
    component: MyPage,
  },
  {
    path: "/summary",
    name: "ranking",
    component: Summary,
  },
  {
    path: "/reports/:name",
    name: "report",
    component: Report,
  },
  {
    path: "/ai-images",
    name: "ai-images",
    component: AIImages,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
